<% var slot = validated_appointment_slot.id ? validated_appointment_slot : appointment_slot %>

<% if (slot.in_person) { %>
  <% if (address.id == validated_address.id) { %>
    <div class="item-icon --address"></div>
    <div class="item-attribute__name"><%= I18n.summary.location %></div>
  <% } else { %>
    <div class="item-icon --address attention"></div>
    <div class="item-attribute__name"><%= I18n.summary.updated_location %></div>
  <% } %>

  <div class="item-attribute__content">
    <% if (AppointmentBooking.config.show_address_nickname_in_wizard_header) { %>
      <div class="address-nickname" translate="no">
        <%- validated_address.address_nickname_with_fallback %>
      </div>
    <% } %>
    <div class="address-first-line" translate="no">
      <%- validated_address.street_address %>
    </div>
    <div class="address-second-line" translate="no">
      <%- validated_address.city %>, <%- validated_address.state %> <%- validated_address.zip_code %>
    </div>
  </div>

  <% if (validated_address.directions_url) { %>
    <div class="item-attribute__action">
      <a href="<%= validated_address.directions_url %>" target="_blank" class="address-directions-link"><%= I18n.summary.map_and_directions %></a>
    </div>
  <% } %>
<% } else {  %>
  <div class="item-icon <%- slot.visit_type_category %>-visit"></div>
  <div class="item-attribute__name"><%- slot.visit_type_name %></div>
  <div class="item-attribute__content">
    <%= slot.visit_type_short_instructions %>
  </div>
<% } %>
